import { useState, useRef, useMemo } from 'react';
import { collection, addDoc, getDocs, doc, updateDoc, query, orderBy, deleteDoc, limit, startAfter, getDoc, where, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase"; // Ajusta la ruta según tu estructura
import { useEffect } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Fecha local (sin cambio a UTC) en formato "YYYY-MM-DD"
function localYMD() {
  const now = new Date();
  const offsetMs = now.getTimezoneOffset() * 60000; // desfase zona horaria en ms
  const localDate = new Date(now.getTime() - offsetMs);
  return localDate.toISOString().slice(0, 10); // "2025-10-24"
}

// Formatea fecha/tiempo en hora local a es-CO
function formatDateTimeLocal(val) {
  if (!val) return '';
  try {
    const d = typeof val?.toDate === 'function' ? val.toDate() : new Date(val);
    if (isNaN(d)) return String(val);
    return d.toLocaleString('es-CO', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
    });
  } catch {
    return String(val);
  }
}

const OutgoingView = ({ onBack, currentUser, products }) => {

const OUTGOING_PAGE_SIZE = 25;
const DELETED_PAGE_SIZE = 25;

const [currentSubView, setCurrentSubView] = useState('manual'); // 'manual', 'sales', 'insumos', 'deletionHistory'
 const [outgoingItems, setOutgoingItems] = useState([]);  const [deletedOutgoingItems, setDeletedOutgoingItems] = useState([]); // Historial de eliminaciones
  const [showForm, setShowForm] = useState(false);
const [formData, setFormData] = useState({
  productId: '',
  productName: '',
  barcode: '',
  quantity: 1,
  reason: '',
  detailedComments: '',
  evidenceImage: '',
  registeredBy: currentUser,
  registrationDate: localYMD()
});

const asUserString = (u) => {
  if (!u) return '—';
  if (typeof u === 'string') return u;
  return u.displayName || u.username || u.name || u.email || u.uid || '—';
};


  const [productSuggestions, setProductSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const barcodeScannerRef = useRef(null);
const [outgoingPage, setOutgoingPage] = useState(1);
const [outgoingCursors, setOutgoingCursors] = useState([null]);
const [hasNextOutgoing, setHasNextOutgoing] = useState(false);
const [loadingOutgoing, setLoadingOutgoing] = useState(false);
const [outgoingError, setOutgoingError] = useState('');
const [outgoingLoaded, setOutgoingLoaded] = useState(false);
const [deletedPage, setDeletedPage] = useState(1);
const [deletedCursors, setDeletedCursors] = useState([null]);
const [hasNextDeleted, setHasNextDeleted] = useState(false);
const [loadingDeleted, setLoadingDeleted] = useState(false);
const [deletedError, setDeletedError] = useState('');
const [deletedLoaded, setDeletedLoaded] = useState(false);
const [savingOutgoing, setSavingOutgoing] = useState(false);
const [deletingId, setDeletingId] = useState('');

 // === Ventas (resumen por producto) ===
 const [salesItems, setSalesItems] = useState([]); // items planos por producto vendido
 // Paginación (50 por página)
 const [salesPage, setSalesPage] = useState(1);
 const salesPageSize = 50;
const [loadingSales, setLoadingSales] = useState(true);
const [salesError, setSalesError] = useState('');
const SALES_CACHE_PREFIX = "valenpos:sales_summary:v2";
const SALES_LIMIT = 200; // máximo de registros en resumen
// --- Filtro por fecha (Ventas resumen) ---
const ymd = (ts) => {
  const date = new Date(ts);
  const offsetMs = date.getTimezoneOffset() * 60000;
  const localDate = new Date(date.getTime() - offsetMs);
  return localDate.toISOString().slice(0, 10);
};
const [salesDateFrom, setSalesDateFrom] = useState(ymd(Date.now() - 7*86400000)); // últimos 7 días
const [salesDateTo, setSalesDateTo] = useState(ymd(Date.now()));
const [showRecipeModal, setShowRecipeModal] = useState(false);
const [selectedRecipeRow, setSelectedRecipeRow] = useState(null);



 // Mapa id -> producto para lookup de unidad
 const productsById = useMemo(() => {
   const m = {};
   (products || []).forEach(p => { m[p.id] = p; });
    return m;
 }, [products]);

  // Solo productos/insumos que SÍ se pueden mover manualmente.
  // La idea es ocultar combos/recetas/etc. que tienen excludeFromEntries === true
  const allowedOutgoingProducts = useMemo(() => {
    return (products || []).filter(p => {
      // si el producto tiene esta bandera en true -> NO se deja sacar manualmente
      if (p.excludeFromEntries === true) return false;
      return true;
    });
  }, [products]);


 // normaliza y decide etiqueta de unidad
const prettyUnit = (comp) => {
   const fallbackByName =
     (products || []).find(p =>
       (p.name || '').toLowerCase() === String(comp.name || '').toLowerCase()
     );
   const unitRaw =
    comp.unit ||
     comp.insumoUnit ||
     productsById[comp.insumoId]?.unit ||
    productsById[comp.productId]?.unit ||
     fallbackByName?.unit ||
     'unidad';
   const u = String(unitRaw).trim().toLowerCase();
   if (u === 'g' || u === 'gr' || u.includes('gram')) return 'g';
  if (u === 'ml' || u.includes('mili')) return 'ml';
   return 'u.';
 };

 // filas visibles de esta página
 const visibleSales = useMemo(() => {
    const start = (salesPage - 1) * salesPageSize;
    return salesItems.slice(start, start + salesPageSize);
 }, [salesItems, salesPage]);

 const totalSalesPages = Math.max(1, Math.ceil(salesItems.length / salesPageSize));


const salesCacheKey = (from, to) => `${SALES_CACHE_PREFIX}:${from || 'all'}:${to || 'all'}`;

const hydrateSalesFromLocal = (from, to) => {
  try {
  const raw = localStorage.getItem(salesCacheKey(from, to));
  if (raw) {
     const cached = JSON.parse(raw);
     if (Array.isArray(cached?.rows) && Date.now() - Number(cached.savedAt || 0) < 5 * 60 * 1000) {
       setSalesItems(cached.rows);
       setLoadingSales(false); // ya hay algo visible
       return true;
     }
    }
 } catch (_error) {}
 return false;
};

const fetchVentasResumen = async (from = salesDateFrom, to = salesDateTo) => {
  setLoadingSales(true);
  setSalesError('');
  try {
    const ventasRef = collection(db, "ventas");
    const constraints = [];
    if (from) constraints.push(where("fecha", ">=", from));
    if (to)   constraints.push(where("fecha", "<=", to));
    constraints.push(orderBy("fecha", "desc"));
    constraints.push(limit(SALES_LIMIT));

    const q = query(ventasRef, ...constraints);
    const snap = await getDocs(q);
    const rows = [];
    snap.forEach(d => {
      const v = d.data();
      const fecha  = v.fecha || (v.date ? String(v.date).slice(0,10) : "");
      const seller = asUserString(v.seller || v.user || "");
      const prods  = Array.isArray(v.products) ? v.products : [];
      for (let i = 0; i < prods.length; i++) {
        const p = prods[i];
        rows.push({
          id: `${d.id}_${p.id || p.name || i}`,
          saleId: d.id,
          fecha,
          seller,
          productName: p.name,
          quantity: Number(p.quantity || 0),
          recipe: Array.isArray(p.recipe) ? p.recipe : null
        });
      }
    });
    setSalesItems(rows);
    setSalesPage(1);
    try {
      localStorage.setItem(salesCacheKey(from, to), JSON.stringify({ rows, savedAt: Date.now() }));
    } catch (_error) {}
  } catch (e) {
    console.error("No se pudo cargar ventas resumen", e);
    setSalesError('No se pudo cargar el resumen de ventas. Revisa la conexión e intenta nuevamente.');
  } finally {
    setLoadingSales(false);
  }
};


useEffect(() => {
  if (currentSubView !== 'sales') return;
  hydrateSalesFromLocal(salesDateFrom, salesDateTo);
  fetchVentasResumen(salesDateFrom, salesDateTo);
}, [currentSubView, salesDateFrom, salesDateTo]);

const reasons = ['Merma', 'Uso Interno', 'Muestra', 'Donacion', 'Otro'];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'quantity' ? parseFloat(value) || 0 : value,
      ...(name === 'productName' ? { productId: '', barcode: '' } : {}),
    }));

if (name === 'productName') {
  if (value.length > 1) {
    const needle = value.toLowerCase();
    const filtered = allowedOutgoingProducts.filter(product =>
      (product.name || '').toLowerCase().includes(needle) ||
      (product.barcode || '').toLowerCase().includes(needle)
    );
    setProductSuggestions(filtered);
    setShowSuggestions(true);
  } else {
    setProductSuggestions([]);
    setShowSuggestions(false);
  }
}
  };

  
  const handleSelectProduct = (product) => {
    setFormData({
      ...formData,
      productId: product.id,
      productName: product.name,
      barcode: product.barcode || ''
    });
    setShowSuggestions(false);
  };

  const handleBarcodeScan = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const scannedBarcode = e.target.value.trim();
const productFound = allowedOutgoingProducts.find(p =>
  String(p.barcode || '').toLowerCase() === scannedBarcode.toLowerCase()
);

      if (productFound) {
        setFormData(prev => ({
          ...prev,
          productId: productFound.id,
          productName: productFound.name,
          barcode: productFound.barcode
        }));
        e.target.value = '';
      } else {
        alert('Producto no encontrado. Verifique el código de barras.');
      }
    }
  };

  const handleEvidenceImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast.error('Selecciona un archivo de imagen válido.');
        e.target.value = '';
        return;
      }
      if (file.size > 600 * 1024) {
        toast.error('La evidencia debe pesar máximo 600 KB para no ralentizar el historial.');
        e.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        setFormData(prev => ({ ...prev, evidenceImage: event.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };

const handleAddOutgoing = async (e) => {
  e.preventDefault();
  if (savingOutgoing) return;

  // Validar producto seleccionado
  if (!formData.productId || !formData.productName) {
    alert("Selecciona un producto válido.");
    return;
  }

// Asegurar que el producto todavía está permitido
const prodMeta = allowedOutgoingProducts.find(p => p.id === formData.productId);
if (!prodMeta) {
  alert("Este producto no permite salidas manuales.");
  return;
}

  // Usaremos transacción para asegurar que no bajemos de 0
  const prodRef = doc(db, "productos", formData.productId);

  try {
setSavingOutgoing(true);
const nowIso = localYMD();

    await runTransaction(db, async (tx) => {
      // 1) Lee stock actual
      const snap = await tx.get(prodRef);
      if (!snap.exists()) throw new Error("El producto no existe");
      const data = snap.data() || {};
      const stockActual = Number(data.stock || 0);
      const qty = Number(formData.quantity || 0);
      if (qty <= 0) throw new Error("Cantidad inválida");

      // 2) Verifica suficiente stock
      if (qty > stockActual) {
        throw new Error(`Stock insuficiente. Disponible: ${stockActual}`);
      }

      // 3) Prepara doc de salida con antes/después
      const salidaRef = doc(collection(db, "salidas"));
      const salida = {
        ...formData,
        registeredBy: asUserString(formData.registeredBy),
        quantity: qty,
        stockAntes: stockActual,
        stockDespues: stockActual - qty,
        fecha: nowIso,
        movementType: 'manual',
        createdAt: serverTimestamp(),
      };

      // 4) Actualiza el producto y crea la salida dentro de la MISMA transacción
      tx.update(prodRef, { stock: stockActual - qty, updatedAt: serverTimestamp() });
      tx.set(salidaRef, salida);
    });

    // Recarga lista (primera página) y limpia formulario
    await cargarSalidasPaginadas(1, null, true);
    setShowForm(false);
setFormData({
  productId: '',
  productName: '',
  barcode: '',
  quantity: 1,
  reason: '',
  detailedComments: '',
  evidenceImage: '',
  registeredBy: asUserString(currentUser),
  registrationDate: localYMD()
});

    toast.success("Salida registrada con éxito.");
  } catch (err) {
    console.error('No se pudo registrar la salida', err);
    toast.error(err.message || "No se pudo registrar la salida.");
  } finally {
    setSavingOutgoing(false);
  }
};

const cargarSalidasPaginadas = async (page = 1, cursor = null, reset = false) => {
  if (loadingOutgoing) return;
  setLoadingOutgoing(true);
  setOutgoingError('');
  try {
    const constraints = [orderBy("fecha", "desc")];
    if (cursor) constraints.push(startAfter(cursor));
    constraints.push(limit(OUTGOING_PAGE_SIZE + 1));
    const snapshot = await getDocs(query(collection(db, "salidas"), ...constraints));
    const pageDocs = snapshot.docs.slice(0, OUTGOING_PAGE_SIZE);
    setOutgoingItems(pageDocs.map(item => ({ id: item.id, ...item.data() })));
    setHasNextOutgoing(snapshot.docs.length > OUTGOING_PAGE_SIZE);
    setOutgoingPage(page);
    setOutgoingLoaded(true);
    if (reset) {
      setOutgoingCursors([null, pageDocs[pageDocs.length - 1] || null]);
    } else {
      setOutgoingCursors(previous => {
        const next = previous.slice(0, page);
        next[page] = pageDocs[pageDocs.length - 1] || null;
        return next;
      });
    }
  } catch (error) {
    console.error('No se pudieron cargar las salidas', error);
    setOutgoingError('No se pudieron cargar las salidas. Revisa la conexión e intenta nuevamente.');
  } finally {
    setLoadingOutgoing(false);
  }
};

const cargarEliminaciones = async (page = 1, cursor = null, reset = false) => {
  if (loadingDeleted) return;
  setLoadingDeleted(true);
  setDeletedError('');
  try {
    const constraints = [orderBy("deletedAt", "desc")];
    if (cursor) constraints.push(startAfter(cursor));
    constraints.push(limit(DELETED_PAGE_SIZE + 1));
    const snapshot = await getDocs(query(collection(db, "salidas_eliminadas"), ...constraints));
    const pageDocs = snapshot.docs.slice(0, DELETED_PAGE_SIZE);
    setDeletedOutgoingItems(pageDocs.map(item => ({ id: item.id, ...item.data() })));
    setHasNextDeleted(snapshot.docs.length > DELETED_PAGE_SIZE);
    setDeletedPage(page);
    setDeletedLoaded(true);
    if (reset) {
      setDeletedCursors([null, pageDocs[pageDocs.length - 1] || null]);
    } else {
      setDeletedCursors(previous => {
        const next = previous.slice(0, page);
        next[page] = pageDocs[pageDocs.length - 1] || null;
        return next;
      });
    }
  } catch (error) {
    console.error('No se pudo cargar el historial de eliminaciones', error);
    setDeletedError('No se pudo cargar el historial. Revisa la conexión e intenta nuevamente.');
  } finally {
    setLoadingDeleted(false);
  }
};
// Cargar salidas solo cuando la subvista lo requiere
useEffect(() => {
  if ((currentSubView === 'manual' || currentSubView === 'insumos') && !outgoingLoaded) {
    cargarSalidasPaginadas(1, null, true);
  }
}, [currentSubView, outgoingLoaded]);

// Cargar historial de eliminaciones solo cuando la subvista está activa
useEffect(() => {
  if (currentSubView !== 'deletionHistory' || deletedLoaded) return;
  cargarEliminaciones(1, null, true);
}, [currentSubView, deletedLoaded]);

const handleDeleteOutgoing = async (id) => {
  if (deletingId) return;
  if (!window.confirm('¿Estás seguro de que quieres eliminar esta salida?')) return;

  const salidaRef = doc(db, "salidas", id);

  try {
    setDeletingId(id);
    await runTransaction(db, async (tx) => {
      // 1) Trae la salida
      const salidaSnap = await tx.get(salidaRef);
      if (!salidaSnap.exists()) throw new Error("La salida no existe");
      const salida = salidaSnap.data();

      // 2) Restaura stock del producto
      if (salida.productId) {
        const prodRef = doc(db, "productos", salida.productId);
        const prodSnap = await tx.get(prodRef);
        if (prodSnap.exists()) {
          const cur = Number(prodSnap.data()?.stock || 0);
          const qty = Number(salida.quantity || 0);
          tx.update(prodRef, { stock: cur + qty, updatedAt: serverTimestamp() });
        }
      }

      // 3) Copia a historial de eliminaciones y borra la salida
      const histRef = doc(collection(db, "salidas_eliminadas"));
      tx.set(histRef, {
        ...salida,
deletedBy: asUserString(currentUser),
deletedAt: localYMD(),
        deletedAtTimestamp: serverTimestamp(),
        originalId: id
      });
      tx.delete(salidaRef);
    });

    setOutgoingItems(previous => previous.filter(item => item.id !== id));
    setDeletedLoaded(false);
    toast.success('Salida eliminada y stock restaurado.');
  } catch (err) {
    console.error(err);
    toast.error(err.message || "No se pudo eliminar la salida.");
  } finally {
    setDeletingId('');
  }
};

const goToOutgoingPage = (page) => {
  const target = Math.max(1, page);
  cargarSalidasPaginadas(target, outgoingCursors[target - 1] || null);
};

const goToDeletedPage = (page) => {
  const target = Math.max(1, page);
  cargarEliminaciones(target, deletedCursors[target - 1] || null);
};

const renderLoadState = (loading, error, retry) => {
  if (loading) {
    return <div className="m-4 rounded-2xl bg-sky-50 px-4 py-5 text-center text-sm font-semibold text-sky-800">Cargando información…</div>;
  }
  if (error) {
    return (
      <div className="m-4 rounded-2xl border border-rose-200 bg-rose-50 p-4 text-center">
        <p className="text-sm font-semibold text-rose-800">{error}</p>
        <button type="button" onClick={retry} className="mt-3 rounded-xl bg-rose-700 px-4 py-2 text-sm font-bold text-white">Reintentar</button>
      </div>
    );
  }
  return null;
};

const renderPager = ({ page, hasNext, loading, onPage }) => (
  <div className="flex flex-col gap-3 border-t border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
    <p className="text-center text-sm font-semibold text-slate-500">Página {page} · máximo {OUTGOING_PAGE_SIZE} registros</p>
    <div className="grid grid-cols-2 gap-2">
      <button type="button" onClick={() => onPage(page - 1)} disabled={loading || page <= 1} className="rounded-xl border border-slate-300 px-4 py-2 text-sm font-bold text-slate-700 disabled:cursor-not-allowed disabled:opacity-40">Anterior</button>
      <button type="button" onClick={() => onPage(page + 1)} disabled={loading || !hasNext} className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-bold text-white disabled:cursor-not-allowed disabled:opacity-40">Siguiente</button>
    </div>
  </div>
);

  const getLossesByCategory = () => {
    const lossesMap = {};
    outgoingItems.filter(item => item.reason === 'Merma').forEach(item => {
      const product = products.find(p => p.id === item.productId);
      const category = product ? product.category : 'Sin Categoría';
      lossesMap[category] = (lossesMap[category] || 0) + item.quantity;
    });
    return Object.entries(lossesMap);
  };

  const manualOutgoingItems = outgoingItems.filter(
    (item) => !(item.reason || '').toLowerCase().startsWith('venta')
  );
  const supplyOutgoingItems = outgoingItems.filter(
    (item) => (item.reason || '').toLowerCase().startsWith('venta')
  );

  const renderSubView = () => {
    switch (currentSubView) {
case 'manual':
          return (
          <>
            {showForm ? (
              <div className="mx-auto max-w-3xl rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm sm:p-8">
                <h2 className="mb-6 text-center text-2xl font-black text-slate-900 sm:text-3xl">Documentar Salida de Inventario</h2>
                <form onSubmit={handleAddOutgoing}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="md:col-span-2 relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Producto*</label>
                      <input
                        type="text"
                        name="productName"
                        value={formData.productName}
                        onChange={handleInputChange}
                        className="w-full rounded-2xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                        required
                        autoComplete="off"
                        placeholder="Buscar o escanear producto..."
                      />
                      {showSuggestions && productSuggestions.length > 0 && (
                        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-auto">
                          {productSuggestions.map(product => (
                            <div
                              key={product.id}
                              className="px-4 py-2 hover:bg-blue-50 cursor-pointer"
                              onClick={() => handleSelectProduct(product)}
                            >
                              <div className="font-medium">{product.name}</div>
                              <div className="text-sm text-gray-500">Código: {product.barcode}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Código de Barras</label>
                      <input
                        type="text"
                        name="barcode"
                        value={formData.barcode}
                        onChange={handleInputChange}
                        onKeyDown={handleBarcodeScan} // Escaneo de código de barras
                        autoFocus
                        placeholder="Escanee aquí..."
                        className="w-full rounded-2xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Cantidad*</label>
                      <input
                        type="number"
                        name="quantity"
                        min="1"
                        value={formData.quantity}
                        onChange={handleInputChange}
                        className="w-full rounded-2xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                        required
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Razón de la Salida*</label>
                      <select
                        name="reason"
                        value={formData.reason}
                        onChange={handleInputChange}
                        className="w-full rounded-2xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                        required
                      >
                        <option value="">Seleccionar...</option>
                        {reasons.map(reason => (
                          <option key={reason} value={reason}>{reason}</option>
                        ))}
                      </select>
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Comentarios Detallados (Opcional)</label>
                      <textarea
                        name="detailedComments"
                        value={formData.detailedComments}
                        onChange={handleInputChange}
                        rows="3"
                        placeholder="Ej: Se derramó en el transporte, dañado en almacén, etc."
                        className="w-full rounded-2xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 resize-none"
                      ></textarea>
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Evidencia (Imagen)</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleEvidenceImageUpload}
                        className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 transition duration-200"
                      />
                      {formData.evidenceImage && (
                        <div className="mt-3 flex justify-center">
                          <img src={formData.evidenceImage} alt="Evidencia" className="h-32 object-contain border rounded-lg" />
                        </div>
                      )}
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Registrado por</label>
                      <input
                        type="text"
value={asUserString(currentUser)}
                        readOnly
                        className="w-full rounded-2xl border border-gray-300 bg-gray-100 px-4 py-3"
                      />
                    </div>
                  </div>

                  <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                    <button
                      type="button"
                      onClick={() => setShowForm(false)}
                      className="rounded-2xl bg-gray-200 px-6 py-3 text-sm font-semibold text-gray-800 transition duration-200 hover:bg-gray-300"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      disabled={savingOutgoing}
                      className="rounded-2xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 disabled:cursor-wait disabled:opacity-60"
                    >
                      {savingOutgoing ? 'Registrando…' : 'Registrar Salida'}
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm">
                {renderLoadState(loadingOutgoing, outgoingError, () => cargarSalidasPaginadas(outgoingPage, outgoingCursors[outgoingPage - 1] || null))}
                <div className="p-4 sm:hidden">
                  {manualOutgoingItems.length > 0 ? (
                    <div className="space-y-3">
                      {manualOutgoingItems.map((item) => (
                        <article key={item.id} className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
                          <div className="flex items-start justify-between gap-3">
                            <div>
                              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
                                {formatDateTimeLocal(item.fecha || item.registrationDate)}
                              </p>
                              <h3 className="mt-1 text-base font-bold text-slate-900">{item.productName}</h3>
                              <p className="mt-1 text-sm text-slate-500">{item.reason}</p>
                            </div>
                            <span className="rounded-full bg-sky-100 px-3 py-1 text-xs font-semibold text-sky-700">
                              {item.quantity}
                            </span>
                          </div>
                          <div className="mt-4 grid grid-cols-2 gap-3 rounded-2xl bg-slate-50 p-3 text-sm">
                            <div>
                              <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Usuario</p>
                              <p className="mt-1 font-semibold text-slate-900">{asUserString(item.registeredBy)}</p>
                            </div>
                            <div>
                              <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Motivo</p>
                              <p className="mt-1 font-semibold text-slate-900">{item.reason}</p>
                            </div>
                          </div>
                          <button
                            onClick={() => handleDeleteOutgoing(item.id)}
                            disabled={Boolean(deletingId)}
                            className="mt-4 w-full rounded-2xl border border-rose-200 px-3 py-3 text-sm font-semibold text-rose-700 transition hover:bg-rose-50 disabled:cursor-wait disabled:opacity-50"
                          >
                            {deletingId === item.id ? 'Eliminando…' : 'Eliminar'}
                          </button>
                        </article>
                      ))}
                    </div>
                  ) : (
                    <div className="rounded-2xl border border-dashed border-slate-200 px-4 py-8 text-center text-sm text-slate-500">
                      No hay salidas registradas.
                    </div>
                  )}
                </div>
                <div className="hidden overflow-x-auto sm:block">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Producto</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Razón</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuario</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
 {manualOutgoingItems.length > 0 ? (
  manualOutgoingItems
   .map((item) => (                          <tr key={item.id} className="hover:bg-gray-50 transition duration-150">
<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
  {formatDateTimeLocal(item.fecha || item.registrationDate)}
</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.productName}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.quantity}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.reason}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{asUserString(item.registeredBy)}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                              <button
                                onClick={() => handleDeleteOutgoing(item.id)}
                                disabled={Boolean(deletingId)}
                                className="text-red-600 hover:text-red-800 transition duration-150 disabled:cursor-wait disabled:opacity-50"
                              >
                                {deletingId === item.id ? 'Eliminando…' : 'Eliminar'}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">
                            No hay salidas registradas.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {renderPager({ page: outgoingPage, hasNext: hasNextOutgoing, loading: loadingOutgoing, onPage: goToOutgoingPage })}
              </div>
            )}
          </>
        );

case 'sales':
  return (
    <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
      <h2 className="mb-6 text-center text-2xl font-black text-slate-900 sm:text-3xl">Ventas (Resumen por Producto)</h2>
      {/* Filtro por fecha */}
<div className="mb-4 flex flex-wrap items-end gap-3">
  <div>
    <label className="block text-xs font-medium text-gray-600 mb-1">Desde</label>
    <input
      type="date"
      value={salesDateFrom}
      onChange={(e) => { setSalesDateFrom(e.target.value); setSalesPage(1); }}
      className="rounded-2xl border px-3 py-3"
    />
  </div>
  <div>
    <label className="block text-xs font-medium text-gray-600 mb-1">Hasta</label>
    <input
      type="date"
      value={salesDateTo}
      onChange={(e) => { setSalesDateTo(e.target.value); setSalesPage(1); }}
      className="rounded-2xl border px-3 py-3"
    />
  </div>

  <button
    type="button"
    onClick={() => { 
      const from = ymd(Date.now() - 7*86400000);
      const to = ymd(Date.now());
      setSalesDateFrom(from); setSalesDateTo(to); setSalesPage(1);
    }}
    className="rounded-2xl border px-3 py-3"
    title="Últimos 7 días"
  >
    Últimos 7 días
  </button>

  <button
    type="button"
    onClick={() => {
      const h = ymd(Date.now());
      setSalesDateFrom(h); setSalesDateTo(h); setSalesPage(1);
    }}
    className="rounded-2xl border px-3 py-3"
    title="Hoy"
  >
    Hoy
  </button>

  <button
    type="button"
    onClick={() => {
      const d = new Date(); d.setDate(d.getDate() - 1);
      const y = ymd(d);
      setSalesDateFrom(y); setSalesDateTo(y); setSalesPage(1);
    }}
    className="rounded-2xl border px-3 py-3"
    title="Ayer"
  >
    Ayer
  </button>

  <button
    type="button"
    onClick={() => { setSalesDateFrom(''); setSalesDateTo(''); setSalesPage(1); }}
    className="ml-auto rounded-2xl px-3 py-3 text-sm text-gray-600 hover:text-gray-800"
    title="Quitar filtros"
  >
    Limpiar
  </button>

  <button
    type="button"
    onClick={() => fetchVentasResumen(salesDateFrom, salesDateTo)}
    disabled={loadingSales}
    className="rounded-2xl bg-slate-900 px-4 py-3 text-sm font-bold text-white disabled:cursor-wait disabled:opacity-50"
  >
    {loadingSales ? 'Actualizando…' : 'Actualizar'}
  </button>

  {salesError && (
    <div className="basis-full rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm font-semibold text-rose-800">
      {salesError}
    </div>
  )}

{showRecipeModal && selectedRecipeRow && (
  <div
    className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-4"
    role="dialog"
    aria-modal="true"
    onClick={() => {
      setShowRecipeModal(false);
      setSelectedRecipeRow(null);
    }}
  >
    <div
      className="bg-white w-full max-w-md rounded-2xl shadow-2xl border border-gray-200 overflow-hidden"
      onClick={(e) => e.stopPropagation()} // evita cerrar si hacen click dentro
    >
      {/* Header */}
      <div className="px-5 py-4 border-b flex items-start justify-between">
        <div>
          <h3 className="text-lg font-bold text-gray-900">
            Desglose de insumos
          </h3>
          <p className="text-sm text-gray-600">
            {selectedRecipeRow.productName} · {selectedRecipeRow.quantity} und
          </p>
        </div>

        <button
          onClick={() => {
            setShowRecipeModal(false);
            setSelectedRecipeRow(null);
          }}
          className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-700"
          aria-label="Cerrar"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24" stroke="currentColor" fill="none">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Body */}
      <div className="px-5 py-4 max-h-[60vh] overflow-y-auto">
        {Array.isArray(selectedRecipeRow.recipe) && selectedRecipeRow.recipe.length > 0 ? (
          <ul className="space-y-2 text-sm text-gray-800">
            {selectedRecipeRow.recipe.map((comp, idx) => {
              const nombre = comp.name || comp.insumoNombre || comp.insumoId;
              const cantTotal =
                Number(comp.qtyPerUnit || comp.qty || 0) *
                Number(selectedRecipeRow.quantity || 0);
              const unidad = prettyUnit(comp);

              return (
                <li
                  key={idx}
                  className="flex justify-between items-start rounded-lg border border-gray-200 bg-gray-50 px-3 py-2"
                >
                  <div className="font-medium text-gray-900 pr-2">
                    {nombre}
                  </div>
                  <div className="text-right text-gray-700 text-sm whitespace-nowrap">
                    {cantTotal} {unidad}
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <p className="text-center text-gray-500 text-sm">
            No hay desglose configurado para este producto.
          </p>
        )}
      </div>

      {/* Footer */}
      <div className="px-5 py-4 border-t bg-gray-50 flex justify-end">
        <button
          onClick={() => {
            setShowRecipeModal(false);
            setSelectedRecipeRow(null);
          }}
          className="px-4 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 shadow"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}


</div>

     <div className="sm:hidden space-y-3">
      {visibleSales.length > 0 ? visibleSales.map((row) => (
        <article key={row.id} className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">{formatDateTimeLocal(row.fecha)}</p>
              <h3 className="mt-1 text-base font-bold text-slate-900">{row.productName}</h3>
              <p className="mt-1 text-sm text-slate-500">{asUserString(row.seller)}</p>
            </div>
            <span className="rounded-full bg-sky-100 px-3 py-1 text-xs font-semibold text-sky-700">
              {row.quantity}
            </span>
          </div>
          {row.recipe ? (
            <button
              onClick={() => {
                setSelectedRecipeRow(row);
                setShowRecipeModal(true);
              }}
              className="mt-4 w-full rounded-2xl border border-sky-200 px-3 py-3 text-sm font-semibold text-sky-700 transition hover:bg-sky-50"
            >
              Ver desglose
            </button>
          ) : (
            <div className="mt-4 rounded-2xl bg-slate-50 px-3 py-3 text-center text-sm text-slate-500">Sin desglose</div>
          )}
        </article>
      )) : (
        <div className="rounded-2xl border border-dashed border-slate-200 px-4 py-8 text-center text-sm text-slate-500">Sin ventas.</div>
      )}
     </div>

     <div className="hidden overflow-x-auto sm:block">
       <table className="min-w-full divide-y divide-gray-200">
         <thead className="bg-gray-50">
            <tr>
          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Producto vendido</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vendedor</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Detalle</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
{visibleSales.length > 0 ? visibleSales.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm text-gray-500">{formatDateTimeLocal(row.fecha)}</td>
                <td className="px-6 py-4 text-sm font-medium text-gray-900">{row.productName}</td>
                <td className="px-6 py-4 text-sm text-gray-500">{row.quantity}</td>
                <td className="px-6 py-4 text-sm text-gray-500">{asUserString(row.seller)}</td>
               <td className="px-6 py-4 text-sm">
{row.recipe ? (
  <button
    onClick={() => {
      setSelectedRecipeRow(row);   // guardamos la fila que el usuario quiere ver
      setShowRecipeModal(true);    // abrimos el modal
    }}
    className="text-blue-600 hover:text-blue-800 underline"
  >
    Ver desglose
  </button>
) : '—'}
                </td>
             </tr>            )) : (
             <tr><td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">Sin ventas.</td></tr>
            )}
         </tbody>
        </table>
      </div>

       {/* Paginador */}
 <div className="flex flex-col gap-3 px-2 pt-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
  <div className="text-sm text-gray-500">
   Mostrando {(salesItems.length ? (salesPage - 1) * salesPageSize + 1 : 0)}–
    {Math.min(salesPage * salesPageSize, salesItems.length)} de {salesItems.length}
  </div>
  <div className="space-x-2">
    <button
     className="px-3 py-1 rounded border disabled:opacity-50"
     onClick={() => setSalesPage(p => Math.max(1, p - 1))}
      disabled={salesPage <= 1}
    >
      ‹ Anterior
    </button>
    <span className="text-sm text-gray-600">Página {salesPage} / {totalSalesPages}</span>
   <button
     className="px-3 py-1 rounded border disabled:opacity-50"
      onClick={() => setSalesPage(p => Math.min(totalSalesPages, p + 1))}
    disabled={salesPage >= totalSalesPages}
   >
      Siguiente ›
    </button>
  </div>
 </div>

    </div>
  );


        
case 'insumos':
          return (
          <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
            <h2 className="text-center text-2xl font-black text-slate-900 sm:text-3xl">Movimientos automáticos por ventas</h2>
            <p className="mb-6 mt-2 text-center text-sm text-slate-500">Se muestran hasta {OUTGOING_PAGE_SIZE} movimientos por página para reducir lecturas.</p>
            {renderLoadState(loadingOutgoing, outgoingError, () => cargarSalidasPaginadas(outgoingPage, outgoingCursors[outgoingPage - 1] || null))}
            <div className="space-y-3 sm:hidden">
              {supplyOutgoingItems.length > 0 ? (
                supplyOutgoingItems.map((item) => (
                  <article key={item.id} className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">{formatDateTimeLocal(item.fecha || item.registrationDate)}</p>
                        <h3 className="mt-1 text-base font-bold text-slate-900">{item.productName}</h3>
                        <p className="mt-1 text-sm text-slate-500">{item.reason}</p>
                      </div>
                      <span className="rounded-full bg-sky-100 px-3 py-1 text-xs font-semibold text-sky-700">{item.quantity}</span>
                    </div>
                    <div className="mt-4 space-y-2 rounded-2xl bg-slate-50 p-3 text-sm">
                      <p><span className="font-semibold text-slate-700">Usuario:</span> {asUserString(item.registeredBy)}</p>
                      <p><span className="font-semibold text-slate-700">Comentarios:</span> {item.detailedComments || 'N/A'}</p>
                      <p>
                        <span className="font-semibold text-slate-700">Evidencia:</span>{' '}
                        {item.evidenceImage ? (
                          <a href={item.evidenceImage} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Ver imagen</a>
                        ) : 'N/A'}
                      </p>
                    </div>
                  </article>
                ))
              ) : (
                <div className="rounded-2xl border border-dashed border-slate-200 px-4 py-8 text-center text-sm text-slate-500">No hay salidas registradas.</div>
              )}
            </div>
            <div className="hidden overflow-x-auto sm:block">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Producto</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Razón</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Comentarios</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuario</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Evidencia</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
 {supplyOutgoingItems.length > 0 ? (
     supplyOutgoingItems
       .map((item) => (                      <tr key={item.id} className="hover:bg-gray-50 transition duration-150">
<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
  {formatDateTimeLocal(item.fecha || item.registrationDate)}
</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.productName}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.quantity}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.reason}</td>
                        <td className="px-6 py-4 whitespace-normal text-sm text-gray-500">{item.detailedComments || 'N/A'}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{asUserString(item.registeredBy)}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {item.evidenceImage ? (
                            <a href={item.evidenceImage} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Ver Imagen</a>
                          ) : 'N/A'}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="px-6 py-4 text-center text-sm text-gray-500">
                        No hay salidas registradas.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {renderPager({ page: outgoingPage, hasNext: hasNextOutgoing, loading: loadingOutgoing, onPage: goToOutgoingPage })}
            <h3 className="text-xl font-bold text-gray-800 mt-8 mb-4 text-center">Mermas visibles en esta página</h3>
            <div className="bg-gray-50 p-4 rounded-lg shadow-inner">
              {getLossesByCategory().length > 0 ? (
                getLossesByCategory().map(([category, totalQty]) => (
                  <p key={category} className="flex justify-between text-lg font-medium text-gray-700 mb-1">
                    <span>{category}:</span>
                    <span>{totalQty} unidades</span>
                  </p>
                ))
              ) : (
                <p className="text-center text-gray-500">No hay pérdidas por categoría registradas.</p>
              )}
            </div>
          </div>
        );
      case 'deletionHistory':
        return (
          <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
            <h2 className="mb-6 text-center text-2xl font-black text-slate-900 sm:text-3xl">Historial de Eliminación de Salidas</h2>
            {renderLoadState(loadingDeleted, deletedError, () => cargarEliminaciones(deletedPage, deletedCursors[deletedPage - 1] || null))}
            <div className="space-y-3 sm:hidden">
              {deletedOutgoingItems.length > 0 ? (
                deletedOutgoingItems.map((item) => (
                  <article key={item.id} className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">{formatDateTimeLocal(item.deletedAt)}</p>
                    <h3 className="mt-1 text-base font-bold text-slate-900">{item.productName}</h3>
                    <div className="mt-4 grid grid-cols-2 gap-3 rounded-2xl bg-slate-50 p-3 text-sm">
                      <div>
                        <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Eliminado por</p>
                        <p className="mt-1 font-semibold text-slate-900">{asUserString(item.deletedBy)}</p>
                      </div>
                      <div>
                        <p className="text-xs uppercase tracking-[0.18em] text-slate-400">Cantidad</p>
                        <p className="mt-1 font-semibold text-slate-900">{item.quantity}</p>
                      </div>
                    </div>
                    <p className="mt-3 text-sm text-slate-600"><span className="font-semibold text-slate-700">Razón:</span> {item.reason}</p>
                  </article>
                ))
              ) : (
                <div className="rounded-2xl border border-dashed border-slate-200 px-4 py-8 text-center text-sm text-slate-500">No hay salidas eliminadas.</div>
              )}
            </div>
            <div className="hidden overflow-x-auto sm:block">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha Eliminación</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Eliminado Por</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Producto</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Razón Original</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {deletedOutgoingItems.length > 0 ? (
                    deletedOutgoingItems.map((item) => (
                      <tr key={item.id} className="hover:bg-gray-50 transition duration-150">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDateTimeLocal(item.deletedAt)}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{asUserString(item.deletedBy)}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.productName}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.quantity}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.reason}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">
                        No hay salidas eliminadas.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {renderPager({ page: deletedPage, hasNext: hasNextDeleted, loading: loadingDeleted, onPage: goToDeletedPage })}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-sky-50 p-3 sm:p-6">
      <div className="mb-6 rounded-[28px] border border-slate-200 bg-white/95 p-4 shadow-sm sm:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <button
          onClick={onBack}
          className="flex items-center justify-center gap-2 rounded-2xl border border-sky-200 px-4 py-3 text-sm font-semibold text-sky-700 transition hover:border-sky-400 hover:text-sky-900 sm:w-fit"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Volver al Menú
        </button>

        <div className="flex-1 text-center lg:text-left">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-700">Inventario</p>
          <h1 className="mt-1 text-2xl font-black text-slate-900 sm:text-4xl">
            {currentSubView === 'manual'
              ? 'Salidas Manuales'
              : currentSubView === 'sales'
              ? 'Ventas (Resumen por Producto)'
              : currentSubView === 'insumos'
              ? 'Salidas por Insumos (Desglose)'
              : 'Historial de Eliminaciones'}
          </h1>
        </div>

 {currentSubView === 'manual' && (
  <button onClick={() => setShowForm(true)} className="flex w-full items-center justify-center rounded-2xl bg-sky-600 px-4 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-700 sm:w-auto">
    {/* icono */}
    Nueva Salida
  </button>
 )}
      </div>
      </div>

 <div className="mb-6 flex gap-2 overflow-x-auto pb-1">
  <button onClick={() => setCurrentSubView('manual')}
    className={`whitespace-nowrap rounded-2xl px-4 py-3 text-sm font-semibold transition ${currentSubView === 'manual' ? 'bg-sky-600 text-white shadow-md' : 'bg-slate-200 text-slate-800 hover:bg-slate-300'}`}>
    Salidas manuales
  </button>
  <button onClick={() => setCurrentSubView('sales')}
   className={`whitespace-nowrap rounded-2xl px-4 py-3 text-sm font-semibold transition ${currentSubView === 'sales' ? 'bg-sky-600 text-white shadow-md' : 'bg-slate-200 text-slate-800 hover:bg-slate-300'}`}>
    Ventas (resumen)
   </button>
  <button onClick={() => setCurrentSubView('insumos')}
    className={`whitespace-nowrap rounded-2xl px-4 py-3 text-sm font-semibold transition ${currentSubView === 'insumos' ? 'bg-sky-600 text-white shadow-md' : 'bg-slate-200 text-slate-800 hover:bg-slate-300'}`}>
    Insumos (desglose)
  </button>
  <button onClick={() => setCurrentSubView('deletionHistory')}
    className={`whitespace-nowrap rounded-2xl px-4 py-3 text-sm font-semibold transition ${currentSubView === 'deletionHistory' ? 'bg-sky-600 text-white shadow-md' : 'bg-slate-200 text-slate-800 hover:bg-slate-300'}`}>
    Historial de eliminaciones
  </button>
 </div>

      {renderSubView()}
    </div>

    
  );
};

export default OutgoingView;

